// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimActivityPostingDto } from './IClaimActivityPostingDto';
import {
    IClaimActivityPostingDtoFromJSON,
    IClaimActivityPostingDtoFromJSONTyped,
    IClaimActivityPostingDtoToJSON,
    IClaimActivityPostingDtoToJSONTyped,
} from './IClaimActivityPostingDto';
import type { IClaimActorDto } from './IClaimActorDto';
import {
    IClaimActorDtoFromJSON,
    IClaimActorDtoFromJSONTyped,
    IClaimActorDtoToJSON,
    IClaimActorDtoToJSONTyped,
} from './IClaimActorDto';
import type { IClaimOffsetDto } from './IClaimOffsetDto';
import {
    IClaimOffsetDtoFromJSON,
    IClaimOffsetDtoFromJSONTyped,
    IClaimOffsetDtoToJSON,
    IClaimOffsetDtoToJSONTyped,
} from './IClaimOffsetDto';
import type { IServiceForDto } from './IServiceForDto';
import {
    IServiceForDtoFromJSON,
    IServiceForDtoFromJSONTyped,
    IServiceForDtoToJSON,
    IServiceForDtoToJSONTyped,
} from './IServiceForDto';
import type { IClaimTransferInfoDto } from './IClaimTransferInfoDto';
import {
    IClaimTransferInfoDtoFromJSON,
    IClaimTransferInfoDtoFromJSONTyped,
    IClaimTransferInfoDtoToJSON,
    IClaimTransferInfoDtoToJSONTyped,
} from './IClaimTransferInfoDto';
import type { IActivityDetail } from './IActivityDetail';
import {
    IActivityDetailFromJSON,
    IActivityDetailFromJSONTyped,
    IActivityDetailToJSON,
    IActivityDetailToJSONTyped,
} from './IActivityDetail';
import type { IClaimNoteDto } from './IClaimNoteDto';
import {
    IClaimNoteDtoFromJSON,
    IClaimNoteDtoFromJSONTyped,
    IClaimNoteDtoToJSON,
    IClaimNoteDtoToJSONTyped,
} from './IClaimNoteDto';
import type { ILetterOfMedicalNecessityDto } from './ILetterOfMedicalNecessityDto';
import {
    ILetterOfMedicalNecessityDtoFromJSON,
    ILetterOfMedicalNecessityDtoFromJSONTyped,
    ILetterOfMedicalNecessityDtoToJSON,
    ILetterOfMedicalNecessityDtoToJSONTyped,
} from './ILetterOfMedicalNecessityDto';
import type { IDeclineReasonTypeWithData } from './IDeclineReasonTypeWithData';
import {
    IDeclineReasonTypeWithDataFromJSON,
    IDeclineReasonTypeWithDataFromJSONTyped,
    IDeclineReasonTypeWithDataToJSON,
    IDeclineReasonTypeWithDataToJSONTyped,
} from './IDeclineReasonTypeWithData';
import type { IServiceDto } from './IServiceDto';
import {
    IServiceDtoFromJSON,
    IServiceDtoFromJSONTyped,
    IServiceDtoToJSON,
    IServiceDtoToJSONTyped,
} from './IServiceDto';
import type { IFeeModificationDto } from './IFeeModificationDto';
import {
    IFeeModificationDtoFromJSON,
    IFeeModificationDtoFromJSONTyped,
    IFeeModificationDtoToJSON,
    IFeeModificationDtoToJSONTyped,
} from './IFeeModificationDto';
import type { IActivityClaimStatusDto } from './IActivityClaimStatusDto';
import {
    IActivityClaimStatusDtoFromJSON,
    IActivityClaimStatusDtoFromJSONTyped,
    IActivityClaimStatusDtoToJSON,
    IActivityClaimStatusDtoToJSONTyped,
} from './IActivityClaimStatusDto';
import type { IActivityDetailNotificationDto } from './IActivityDetailNotificationDto';
import {
    IActivityDetailNotificationDtoFromJSON,
    IActivityDetailNotificationDtoFromJSONTyped,
    IActivityDetailNotificationDtoToJSON,
    IActivityDetailNotificationDtoToJSONTyped,
} from './IActivityDetailNotificationDto';
import type { IFeeDto } from './IFeeDto';
import {
    IFeeDtoFromJSON,
    IFeeDtoFromJSONTyped,
    IFeeDtoToJSON,
    IFeeDtoToJSONTyped,
} from './IFeeDto';
import type { IStatusDetail } from './IStatusDetail';
import {
    IStatusDetailFromJSON,
    IStatusDetailFromJSONTyped,
    IStatusDetailToJSON,
    IStatusDetailToJSONTyped,
} from './IStatusDetail';

/**
 * 
 * @export
 * @interface IClaimActivityDetails
 */
export interface IClaimActivityDetails {
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityDetails
     */
    claim_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityDetails
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityDetails
     */
    approved_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityDetails
     */
    paid_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityDetails
     */
    payment_method_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityDetails
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityDetails
     */
    provider_id?: string;
    /**
     * 
     * @type {Date}
     * @memberof IClaimActivityDetails
     */
    created_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityDetails
     */
    category_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityDetails
     */
    category_type?: IClaimActivityDetailsCategoryTypeEnum;
    /**
     * 
     * @type {IServiceForDto}
     * @memberof IClaimActivityDetails
     */
    service_for?: IServiceForDto;
    /**
     * 
     * @type {IServiceDto}
     * @memberof IClaimActivityDetails
     */
    service?: IServiceDto;
    /**
     * 
     * @type {Date}
     * @memberof IClaimActivityDetails
     * @deprecated
     */
    service_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimActivityDetails
     */
    local_date_service_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityDetails
     */
    payment_type?: IClaimActivityDetailsPaymentTypeEnum;
    /**
     * 
     * @type {Array<IActivityClaimStatusDto>}
     * @memberof IClaimActivityDetails
     */
    statuses?: Array<IActivityClaimStatusDto>;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityDetails
     */
    processing_status?: IClaimActivityDetailsProcessingStatusEnum;
    /**
     * 
     * @type {Array<IActivityDetailNotificationDto>}
     * @memberof IClaimActivityDetails
     */
    notifications?: Array<IActivityDetailNotificationDto>;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityDetails
     */
    document_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityDetails
     */
    provider_invoice?: string;
    /**
     * 
     * @type {Array<IClaimActivityPostingDto>}
     * @memberof IClaimActivityDetails
     */
    postings?: Array<IClaimActivityPostingDto>;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityDetails
     */
    external_identifier?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityDetails
     */
    apply_deductible_amount?: number;
    /**
     * 
     * @type {Array<IDeclineReasonTypeWithData>}
     * @memberof IClaimActivityDetails
     */
    decline_reason_types?: Array<IDeclineReasonTypeWithData>;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityDetails
     */
    processing_substatus_type?: IClaimActivityDetailsProcessingSubstatusTypeEnum;
    /**
     * 
     * @type {Array<IClaimNoteDto>}
     * @memberof IClaimActivityDetails
     */
    claim_note_dto_list?: Array<IClaimNoteDto>;
    /**
     * 
     * @type {Array<IClaimTransferInfoDto>}
     * @memberof IClaimActivityDetails
     */
    claim_transfers?: Array<IClaimTransferInfoDto>;
    /**
     * 
     * @type {IClaimActorDto}
     * @memberof IClaimActivityDetails
     */
    claim_actor_dto?: IClaimActorDto;
    /**
     * 
     * @type {Array<IClaimOffsetDto>}
     * @memberof IClaimActivityDetails
     */
    claim_offset_dtos?: Array<IClaimOffsetDto>;
    /**
     * 
     * @type {Array<IFeeDto>}
     * @memberof IClaimActivityDetails
     */
    payment_fees?: Array<IFeeDto>;
    /**
     * 
     * @type {Array<IFeeModificationDto>}
     * @memberof IClaimActivityDetails
     */
    fee_modifications?: Array<IFeeModificationDto>;
    /**
     * 
     * @type {Array<IActivityDetail>}
     * @memberof IClaimActivityDetails
     */
    activity_details?: Array<IActivityDetail>;
    /**
     * 
     * @type {Array<IActivityDetail>}
     * @memberof IClaimActivityDetails
     */
    activity_details_v2?: Array<IActivityDetail>;
    /**
     * 
     * @type {Array<IActivityDetail>}
     * @memberof IClaimActivityDetails
     */
    activity_details_v3?: Array<IActivityDetail>;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityDetails
     */
    employee_notes?: string;
    /**
     * 
     * @type {Array<IStatusDetail>}
     * @memberof IClaimActivityDetails
     */
    status_details?: Array<IStatusDetail>;
    /**
     * 
     * @type {Array<ILetterOfMedicalNecessityDto>}
     * @memberof IClaimActivityDetails
     */
    letter_of_medical_necessities?: Array<ILetterOfMedicalNecessityDto>;
}

/**
* @export
* @enum {string}
*/
export enum IClaimActivityDetailsCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}
/**
* @export
* @enum {string}
*/
export enum IClaimActivityDetailsPaymentTypeEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}
/**
* @export
* @enum {string}
*/
export enum IClaimActivityDetailsProcessingStatusEnum {
    SUBMITTED = 'SUBMITTED',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    PROCESSING = 'PROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAID = 'REPAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    AUTHORIZED = 'AUTHORIZED',
    DECLINED = 'DECLINED',
    EXPIRED = 'EXPIRED',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    DEDUCTIBLE_TRACKING = 'DEDUCTIBLE_TRACKING',
    ACTION_REQUIRED = 'ACTION_REQUIRED',
    STOP_PROCESSING = 'STOP_PROCESSING',
    VOIDED = 'VOIDED',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
* @export
* @enum {string}
*/
export enum IClaimActivityDetailsProcessingSubstatusTypeEnum {
    DOCS_NEEDED = 'DOCS_NEEDED',
    CARRIER_CLAIM = 'CARRIER_CLAIM',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PAYMENT_REJECTED = 'PAYMENT_REJECTED',
    REPAYMENT_REJECTED = 'REPAYMENT_REJECTED',
    PARTIAL_REPAYMENT = 'PARTIAL_REPAYMENT',
    FULL_REPAYMENT = 'FULL_REPAYMENT',
    PARTIAL_PAYMENT = 'PARTIAL_PAYMENT'
}


/**
 * Check if a given object implements the IClaimActivityDetails interface.
 */
export function instanceOfIClaimActivityDetails(value: object): value is IClaimActivityDetails {
    return true;
}

export function IClaimActivityDetailsFromJSON(json: any): IClaimActivityDetails {
    return IClaimActivityDetailsFromJSONTyped(json, false);
}

export function IClaimActivityDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimActivityDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'approved_amount': json['approved_amount'] == null ? undefined : json['approved_amount'],
        'paid_amount': json['paid_amount'] == null ? undefined : json['paid_amount'],
        'payment_method_id': json['payment_method_id'] == null ? undefined : json['payment_method_id'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'category_id': json['category_id'] == null ? undefined : json['category_id'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'service_for': json['service_for'] == null ? undefined : IServiceForDtoFromJSON(json['service_for']),
        'service': json['service'] == null ? undefined : IServiceDtoFromJSON(json['service']),
        'service_on': json['service_on'] == null ? undefined : (new Date(json['service_on'])),
        'local_date_service_on': json['local_date_service_on'] == null ? undefined : (new Date(json['local_date_service_on'])),
        'payment_type': json['payment_type'] == null ? undefined : json['payment_type'],
        'statuses': json['statuses'] == null ? undefined : ((json['statuses'] as Array<any>).map(IActivityClaimStatusDtoFromJSON)),
        'processing_status': json['processing_status'] == null ? undefined : json['processing_status'],
        'notifications': json['notifications'] == null ? undefined : ((json['notifications'] as Array<any>).map(IActivityDetailNotificationDtoFromJSON)),
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'provider_invoice': json['provider_invoice'] == null ? undefined : json['provider_invoice'],
        'postings': json['postings'] == null ? undefined : ((json['postings'] as Array<any>).map(IClaimActivityPostingDtoFromJSON)),
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'apply_deductible_amount': json['apply_deductible_amount'] == null ? undefined : json['apply_deductible_amount'],
        'decline_reason_types': json['decline_reason_types'] == null ? undefined : ((json['decline_reason_types'] as Array<any>).map(IDeclineReasonTypeWithDataFromJSON)),
        'processing_substatus_type': json['processing_substatus_type'] == null ? undefined : json['processing_substatus_type'],
        'claim_note_dto_list': json['claim_note_dto_list'] == null ? undefined : ((json['claim_note_dto_list'] as Array<any>).map(IClaimNoteDtoFromJSON)),
        'claim_transfers': json['claim_transfers'] == null ? undefined : ((json['claim_transfers'] as Array<any>).map(IClaimTransferInfoDtoFromJSON)),
        'claim_actor_dto': json['claim_actor_dto'] == null ? undefined : IClaimActorDtoFromJSON(json['claim_actor_dto']),
        'claim_offset_dtos': json['claim_offset_dtos'] == null ? undefined : ((json['claim_offset_dtos'] as Array<any>).map(IClaimOffsetDtoFromJSON)),
        'payment_fees': json['payment_fees'] == null ? undefined : ((json['payment_fees'] as Array<any>).map(IFeeDtoFromJSON)),
        'fee_modifications': json['fee_modifications'] == null ? undefined : ((json['fee_modifications'] as Array<any>).map(IFeeModificationDtoFromJSON)),
        'activity_details': json['activity_details'] == null ? undefined : ((json['activity_details'] as Array<any>).map(IActivityDetailFromJSON)),
        'activity_details_v2': json['activity_details_v2'] == null ? undefined : ((json['activity_details_v2'] as Array<any>).map(IActivityDetailFromJSON)),
        'activity_details_v3': json['activity_details_v3'] == null ? undefined : ((json['activity_details_v3'] as Array<any>).map(IActivityDetailFromJSON)),
        'employee_notes': json['employee_notes'] == null ? undefined : json['employee_notes'],
        'status_details': json['status_details'] == null ? undefined : ((json['status_details'] as Array<any>).map(IStatusDetailFromJSON)),
        'letter_of_medical_necessities': json['letter_of_medical_necessities'] == null ? undefined : ((json['letter_of_medical_necessities'] as Array<any>).map(ILetterOfMedicalNecessityDtoFromJSON)),
    };
}

export function IClaimActivityDetailsToJSON(json: any): IClaimActivityDetails {
    return IClaimActivityDetailsToJSONTyped(json, false);
}

export function IClaimActivityDetailsToJSONTyped(value?: IClaimActivityDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_id': value['claim_id'],
        'amount': value['amount'],
        'approved_amount': value['approved_amount'],
        'paid_amount': value['paid_amount'],
        'payment_method_id': value['payment_method_id'],
        'memo': value['memo'],
        'provider_id': value['provider_id'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'category_id': value['category_id'],
        'category_type': value['category_type'],
        'service_for': IServiceForDtoToJSON(value['service_for']),
        'service': IServiceDtoToJSON(value['service']),
        'service_on': value['service_on'] == null ? undefined : ((value['service_on']).toISOString()),
        'local_date_service_on': value['local_date_service_on'] == null ? undefined : ((value['local_date_service_on']).toISOString().substring(0,10)),
        'payment_type': value['payment_type'],
        'statuses': value['statuses'] == null ? undefined : ((value['statuses'] as Array<any>).map(IActivityClaimStatusDtoToJSON)),
        'processing_status': value['processing_status'],
        'notifications': value['notifications'] == null ? undefined : ((value['notifications'] as Array<any>).map(IActivityDetailNotificationDtoToJSON)),
        'document_id': value['document_id'],
        'provider_invoice': value['provider_invoice'],
        'postings': value['postings'] == null ? undefined : ((value['postings'] as Array<any>).map(IClaimActivityPostingDtoToJSON)),
        'external_identifier': value['external_identifier'],
        'apply_deductible_amount': value['apply_deductible_amount'],
        'decline_reason_types': value['decline_reason_types'] == null ? undefined : ((value['decline_reason_types'] as Array<any>).map(IDeclineReasonTypeWithDataToJSON)),
        'processing_substatus_type': value['processing_substatus_type'],
        'claim_note_dto_list': value['claim_note_dto_list'] == null ? undefined : ((value['claim_note_dto_list'] as Array<any>).map(IClaimNoteDtoToJSON)),
        'claim_transfers': value['claim_transfers'] == null ? undefined : ((value['claim_transfers'] as Array<any>).map(IClaimTransferInfoDtoToJSON)),
        'claim_actor_dto': IClaimActorDtoToJSON(value['claim_actor_dto']),
        'claim_offset_dtos': value['claim_offset_dtos'] == null ? undefined : ((value['claim_offset_dtos'] as Array<any>).map(IClaimOffsetDtoToJSON)),
        'payment_fees': value['payment_fees'] == null ? undefined : ((value['payment_fees'] as Array<any>).map(IFeeDtoToJSON)),
        'fee_modifications': value['fee_modifications'] == null ? undefined : ((value['fee_modifications'] as Array<any>).map(IFeeModificationDtoToJSON)),
        'activity_details': value['activity_details'] == null ? undefined : ((value['activity_details'] as Array<any>).map(IActivityDetailToJSON)),
        'activity_details_v2': value['activity_details_v2'] == null ? undefined : ((value['activity_details_v2'] as Array<any>).map(IActivityDetailToJSON)),
        'activity_details_v3': value['activity_details_v3'] == null ? undefined : ((value['activity_details_v3'] as Array<any>).map(IActivityDetailToJSON)),
        'employee_notes': value['employee_notes'],
        'status_details': value['status_details'] == null ? undefined : ((value['status_details'] as Array<any>).map(IStatusDetailToJSON)),
        'letter_of_medical_necessities': value['letter_of_medical_necessities'] == null ? undefined : ((value['letter_of_medical_necessities'] as Array<any>).map(ILetterOfMedicalNecessityDtoToJSON)),
    };
}

